import { render, staticRenderFns } from "./ProductDesignFormArtwork.vue?vue&type=template&id=57fa0260&"
import script from "./ProductDesignFormArtwork.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormArtwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports